import { DataView } from "primereact/dataview";
import React from "react";
import ImageButton from "../buttons/ImageButton";
import { Col, Row } from "react-bootstrap";
import downloadIcon from './../../assets/images/downloadIcon.png'
import downloadIconFocus from './../../assets/images/downloadIconFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import { deleteAsset, downloadAsset, uploadAsset } from "../../assets/assetsSlice";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { useDispatch } from "react-redux";
import { showSuccessToast, showErrorToast } from "../../app/utils/helpers";
import Langs from "../../app/lang/langs";

export function AssetsPannel(props) {
    const dispatch = useDispatch();
    const assetTemplate = (asset, index) => {
        const downBtn = (asset) => {
            return (
                <ImageButton
                    onClick={() => {
                        dispatch(
                            downloadAsset({
                                tableName: asset.table_name,
                                idParent: asset.id_parent,
                                filename: asset.filename,
                            })
                        )
                    }}
                    image={downloadIcon}
                    imageFocus={downloadIconFocus}
                    active={true}
                    width={22}
                />
            )
        }
        const deleteBtn = (asset) => {
            return (
                <ImageButton
                    onClick={(e) => confirmDelete(e, asset)}
                    image={deleteIcon}
                    imageFocus={deleteIconFocus}
                    active={true}
                    width={22}
                />
            );
        };
        return (
            <Row className='py-2' style={{ borderBottom: "1px #D9D9D9 solid" }}>
                <Col lg={10}>
                    {asset.filename}
                </Col>
                <Col lg={1}>
                    {downBtn(asset)}
                </Col>
                <Col lg={1}>
                    {!props.readOnly && deleteBtn(asset)}
                </Col>
            </Row>
        )
    }
    const assetListTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((asset, index) => {
            return assetTemplate(asset, index);
        });
        return <div className="grid grid-nogutter">{list}</div>;
    };
    const uploadAssetTemplate = (file, idParent, tableName) => {
        if (!file) return;
        console.log(file);
        const filename = file.name;
        if (!idParent || !tableName) {
            showErrorToast('Erreur lors de l\'envoi du fichier');
            return;
        }
        dispatch(uploadAsset({
            file,
            tableName,
            idParent,
            filename
        }))
            .then((actionResponse) => {
                if (uploadAsset.fulfilled.match(actionResponse)) {
                    if (props.parentSetter) {
                        let assetTemp = { filename: filename, table_name: tableName, id_parent: idParent };
                        props.parentSetter((prev) => ({
                            ...prev,
                            assets: [...(prev.assets || []), assetTemp]
                        }));
                    }
                    props.uploadCallBackFunction();
                }
            })
            .catch((error) => {
                console.error('Error handling in uploadAsset:', error);
            });
    }

    const accept = (event, assetToDelete) => {
        if (assetToDelete) {
            dispatch(
                deleteAsset({
                    tableName: assetToDelete.table_name,
                    idParent: assetToDelete.id_parent,
                    filename: assetToDelete.filename,
                })
            )
                .then((actionResponse) => {
                    if (deleteAsset.fulfilled.match(actionResponse)) {
                        showSuccessToast('Fichier supprimé avec succès');
                        if (props.parentSetter) {
                            props.parentSetter((prev) => ({ ...prev, assets: prev.assets.filter((asset) => asset.filename !== assetToDelete.filename) }));
                        }
                        props.deleteCallBackFunction();
                    }
                })
                .catch((error) => {
                    console.error('Error handling in deleteAsset:', error);
                });
        } else {
            return
        }
    };

    const reject = () => {
        return
    };

    const isLimitReached = props.limitLength
        ? Array.isArray(props.assets) && (props.assets.length >= props.limitLength)
        : false;
    const confirmDelete = (event, asset) => {
        confirmDialog({
            target: event.currentTarget,
            message: 'Voulez-vous supprimer ce fichier ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger rounded',
            rejectClassName: 'p-button-secondary rounded me-2',
            acceptIcon: 'pi pi-trash',
            acceptLabel: 'Effacer',
            rejectLabel: 'Annuler',
            accept: (event) => accept(event, asset),
            reject
        });
    };
    const assetPannal = () => {
        return (
            <div>
                <DataView
                    value={props.assets || []}
                    listTemplate={assetListTemplate}
                    paginator
                    paginatorPosition="top"
                    rows={5}
                    className="card p-2"
                    style={{ height: "340px", width: "25rem" }}
                />
                {!isLimitReached && !props.readOnly && <input
                    className="form-control"
                    type="file"
                    id="formFile"
                    onChange={(e) => { uploadAssetTemplate(e.target.files[0], props.idParent, props.tableName) }}
                    style={{ marginTop: '10px' }}
                />}
            </div>
        )
    };
    return (
        <div>
            <Row>
                <Col lg={12} className="mb-3 pe-3 p-fluid align-items-center border-top pt-3 mt-3">
                    <h3>
                        <Langs str={props.label} />
                    </h3>
                </Col>
                <Col lg={6} className="mb-3 pe-3 p-fluid">
                    {assetPannal()}
                </Col>
            </Row>
        </div>
    )
}